import * as ambassadorWixEcomSubscriptionContractsV1SubscriptionContract from './ecom-subscription-contracts-v1-subscription-contract-subscription-contracts.http.js';
import * as ambassadorWixEcomSubscriptionContractsV1SubscriptionContractTypes from './ecom-subscription-contracts-v1-subscription-contract-subscription-contracts.types.js';
import * as ambassadorWixEcomSubscriptionContractsV1SubscriptionContractUniversalTypes from './ecom-subscription-contracts-v1-subscription-contract-subscription-contracts.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getSubscriptionContract(): __PublicMethodMetaInfo<
  'GET',
  { subscriptionContractId: string },
  ambassadorWixEcomSubscriptionContractsV1SubscriptionContractUniversalTypes.GetSubscriptionContractRequest,
  ambassadorWixEcomSubscriptionContractsV1SubscriptionContractTypes.GetSubscriptionContractRequest,
  ambassadorWixEcomSubscriptionContractsV1SubscriptionContractUniversalTypes.GetSubscriptionContractResponse,
  ambassadorWixEcomSubscriptionContractsV1SubscriptionContractTypes.GetSubscriptionContractResponse
> {
  const payload = { subscriptionContractId: ':subscriptionContractId' } as any;

  const getRequestOptions =
    ambassadorWixEcomSubscriptionContractsV1SubscriptionContract.getSubscriptionContract(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/subscription-contracts/{subscriptionContractId}',
    pathParams: { subscriptionContractId: 'subscriptionContractId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function querySubscriptionContracts(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixEcomSubscriptionContractsV1SubscriptionContractUniversalTypes.QuerySubscriptionContractsRequest,
  ambassadorWixEcomSubscriptionContractsV1SubscriptionContractTypes.QuerySubscriptionContractsRequest,
  ambassadorWixEcomSubscriptionContractsV1SubscriptionContractUniversalTypes.QuerySubscriptionContractsResponse,
  ambassadorWixEcomSubscriptionContractsV1SubscriptionContractTypes.QuerySubscriptionContractsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomSubscriptionContractsV1SubscriptionContract.querySubscriptionContracts(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/subscription-contracts/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  SubscriptionContract as SubscriptionContractOriginal,
  V1SubscriptionDescription as V1SubscriptionDescriptionOriginal,
  V1SubscriptionSettings as V1SubscriptionSettingsOriginal,
  SubscriptionFrequency as SubscriptionFrequencyOriginal,
  SubscriptionFrequencyWithLiterals as SubscriptionFrequencyWithLiteralsOriginal,
  V1FreeTrialPeriod as V1FreeTrialPeriodOriginal,
  V1BillingSettings as V1BillingSettingsOriginal,
  SubscriptionSettingsProductPeriodAlignment as SubscriptionSettingsProductPeriodAlignmentOriginal,
  SubscriptionSettingsProductPeriodAlignmentWithLiterals as SubscriptionSettingsProductPeriodAlignmentWithLiteralsOriginal,
  OrderLineItem as OrderLineItemOriginal,
  ProductName as ProductNameOriginal,
  CatalogReference as CatalogReferenceOriginal,
  Price as PriceOriginal,
  DescriptionLine as DescriptionLineOriginal,
  DescriptionLineValueOneOf as DescriptionLineValueOneOfOriginal,
  DescriptionLineDescriptionLineValueOneOf as DescriptionLineDescriptionLineValueOneOfOriginal,
  DescriptionLineName as DescriptionLineNameOriginal,
  PlainTextValue as PlainTextValueOriginal,
  Color as ColorOriginal,
  DescriptionLineType as DescriptionLineTypeOriginal,
  DescriptionLineTypeWithLiterals as DescriptionLineTypeWithLiteralsOriginal,
  Image as ImageOriginal,
  FocalPoint as FocalPointOriginal,
  PhysicalProperties as PhysicalPropertiesOriginal,
  Dimensions as DimensionsOriginal,
  DimensionsUnit as DimensionsUnitOriginal,
  DimensionsUnitWithLiterals as DimensionsUnitWithLiteralsOriginal,
  ItemType as ItemTypeOriginal,
  ItemTypeItemTypeDataOneOf as ItemTypeItemTypeDataOneOfOriginal,
  ItemTypePreset as ItemTypePresetOriginal,
  ItemTypePresetWithLiterals as ItemTypePresetWithLiteralsOriginal,
  RestockLocation as RestockLocationOriginal,
  PaymentOptionType as PaymentOptionTypeOriginal,
  PaymentOptionTypeWithLiterals as PaymentOptionTypeWithLiteralsOriginal,
  ItemTaxFullDetails as ItemTaxFullDetailsOriginal,
  LineItemTaxInfo as LineItemTaxInfoOriginal,
  LineItemTaxBreakdown as LineItemTaxBreakdownOriginal,
  JurisdictionType as JurisdictionTypeOriginal,
  JurisdictionTypeWithLiterals as JurisdictionTypeWithLiteralsOriginal,
  DigitalFile as DigitalFileOriginal,
  SubscriptionInfo as SubscriptionInfoOriginal,
  SubscriptionTitle as SubscriptionTitleOriginal,
  SubscriptionDescription as SubscriptionDescriptionOriginal,
  SubscriptionSettings as SubscriptionSettingsOriginal,
  V2SubscriptionFrequency as V2SubscriptionFrequencyOriginal,
  V2SubscriptionFrequencyWithLiterals as V2SubscriptionFrequencyWithLiteralsOriginal,
  FreeTrialPeriod as FreeTrialPeriodOriginal,
  BillingSettings as BillingSettingsOriginal,
  ProductPeriodAlignment as ProductPeriodAlignmentOriginal,
  ProductPeriodAlignmentWithLiterals as ProductPeriodAlignmentWithLiteralsOriginal,
  BillingAdjustment as BillingAdjustmentOriginal,
  AdjustmentType as AdjustmentTypeOriginal,
  AdjustmentTypeWithLiterals as AdjustmentTypeWithLiteralsOriginal,
  BillingAdjustmentPriceSummary as BillingAdjustmentPriceSummaryOriginal,
  PriceDescription as PriceDescriptionOriginal,
  LocationAndQuantity as LocationAndQuantityOriginal,
  TaxableAddress as TaxableAddressOriginal,
  TaxableAddressTaxableAddressDataOneOf as TaxableAddressTaxableAddressDataOneOfOriginal,
  TaxableAddressType as TaxableAddressTypeOriginal,
  TaxableAddressTypeWithLiterals as TaxableAddressTypeWithLiteralsOriginal,
  DecimalQuantity as DecimalQuantityOriginal,
  DecimalQuantityUnitOneOf as DecimalQuantityUnitOneOfOriginal,
  TranslatableString as TranslatableStringOriginal,
  MeasurementUnit as MeasurementUnitOriginal,
  MeasurementUnitWithLiterals as MeasurementUnitWithLiteralsOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  ModifierGroup as ModifierGroupOriginal,
  ItemModifier as ItemModifierOriginal,
  BuyerInfo as BuyerInfoOriginal,
  BuyerInfoIdOneOf as BuyerInfoIdOneOfOriginal,
  WeightUnit as WeightUnitOriginal,
  WeightUnitWithLiterals as WeightUnitWithLiteralsOriginal,
  CurrencyConversionDetails as CurrencyConversionDetailsOriginal,
  PriceSummary as PriceSummaryOriginal,
  PlatformFeeSummary as PlatformFeeSummaryOriginal,
  PlatformFee as PlatformFeeOriginal,
  ChargeType as ChargeTypeOriginal,
  ChargeTypeWithLiterals as ChargeTypeWithLiteralsOriginal,
  AddressWithContact as AddressWithContactOriginal,
  Address as AddressOriginal,
  StreetAddress as StreetAddressOriginal,
  AddressLocation as AddressLocationOriginal,
  FullAddressContactDetails as FullAddressContactDetailsOriginal,
  VatId as VatIdOriginal,
  VatType as VatTypeOriginal,
  VatTypeWithLiterals as VatTypeWithLiteralsOriginal,
  ShippingInformation as ShippingInformationOriginal,
  DeliveryLogistics as DeliveryLogisticsOriginal,
  DeliveryLogisticsAddressOneOf as DeliveryLogisticsAddressOneOfOriginal,
  PickupDetails as PickupDetailsOriginal,
  PickupAddress as PickupAddressOriginal,
  PickupMethod as PickupMethodOriginal,
  PickupMethodWithLiterals as PickupMethodWithLiteralsOriginal,
  DeliveryTimeSlot as DeliveryTimeSlotOriginal,
  ShippingPrice as ShippingPriceOriginal,
  ShippingRegion as ShippingRegionOriginal,
  OrderTaxInfo as OrderTaxInfoOriginal,
  OrderTaxBreakdown as OrderTaxBreakdownOriginal,
  AppliedDiscount as AppliedDiscountOriginal,
  AppliedDiscountDiscountSourceOneOf as AppliedDiscountDiscountSourceOneOfOriginal,
  DiscountType as DiscountTypeOriginal,
  DiscountTypeWithLiterals as DiscountTypeWithLiteralsOriginal,
  Coupon as CouponOriginal,
  MerchantDiscount as MerchantDiscountOriginal,
  MerchantDiscountMerchantDiscountReasonOneOf as MerchantDiscountMerchantDiscountReasonOneOfOriginal,
  DiscountReason as DiscountReasonOriginal,
  DiscountReasonWithLiterals as DiscountReasonWithLiteralsOriginal,
  DiscountRule as DiscountRuleOriginal,
  DiscountRuleName as DiscountRuleNameOriginal,
  LineItemDiscount as LineItemDiscountOriginal,
  ItemCombination as ItemCombinationOriginal,
  ItemCombinationLineItem as ItemCombinationLineItemOriginal,
  ChannelInfo as ChannelInfoOriginal,
  ChannelType as ChannelTypeOriginal,
  ChannelTypeWithLiterals as ChannelTypeWithLiteralsOriginal,
  CustomField as CustomFieldOriginal,
  V1SubscriptionTitle as V1SubscriptionTitleOriginal,
  AdditionalFee as AdditionalFeeOriginal,
  AdditionalFeeSource as AdditionalFeeSourceOriginal,
  AdditionalFeeSourceWithLiterals as AdditionalFeeSourceWithLiteralsOriginal,
  Location as LocationOriginal,
  SubscriptionContractSettings as SubscriptionContractSettingsOriginal,
  SpecificItemsCouponBehavior as SpecificItemsCouponBehaviorOriginal,
  SpecificItemsCouponBehaviorWithLiterals as SpecificItemsCouponBehaviorWithLiteralsOriginal,
  SubscriptionContractActivity as SubscriptionContractActivityOriginal,
  SubscriptionContractActivityTargetOneOf as SubscriptionContractActivityTargetOneOfOriginal,
  SubscriptionContractActivityContentOneOf as SubscriptionContractActivityContentOneOfOriginal,
  ContractTarget as ContractTargetOriginal,
  ActivityAuthor as ActivityAuthorOriginal,
  ActivityAuthorValueOneOf as ActivityAuthorValueOneOfOriginal,
  ChangesAppliedActivity as ChangesAppliedActivityOriginal,
  ChangesAppliedActivityTargetOneOf as ChangesAppliedActivityTargetOneOfOriginal,
  ContractChange as ContractChangeOriginal,
  ContractChangeValueOneOf as ContractChangeValueOneOfOriginal,
  LineItemChanges as LineItemChangesOriginal,
  LineItemQuantityChangeType as LineItemQuantityChangeTypeOriginal,
  LineItemQuantityChangeTypeWithLiterals as LineItemQuantityChangeTypeWithLiteralsOriginal,
  LineItemQuantityChange as LineItemQuantityChangeOriginal,
  ManagedLineItem as ManagedLineItemOriginal,
  ManagedDiscount as ManagedDiscountOriginal,
  TranslatedValue as TranslatedValueOriginal,
  ManagedAdditionalFee as ManagedAdditionalFeeOriginal,
  TotalPriceChange as TotalPriceChangeOriginal,
  ActivityType as ActivityTypeOriginal,
  ActivityTypeWithLiterals as ActivityTypeWithLiteralsOriginal,
  SubscriptionContractCanceled as SubscriptionContractCanceledOriginal,
  ActionInitiator as ActionInitiatorOriginal,
  ActionInitiatorWithLiterals as ActionInitiatorWithLiteralsOriginal,
  SubscriptionContractExpired as SubscriptionContractExpiredOriginal,
  SubscriptionContractChangesCommitted as SubscriptionContractChangesCommittedOriginal,
  SubscriptionContractDiffs as SubscriptionContractDiffsOriginal,
  LineItemDelta as LineItemDeltaOriginal,
  ChangeType as ChangeTypeOriginal,
  ChangeTypeWithLiterals as ChangeTypeWithLiteralsOriginal,
  AppliedDiscountDelta as AppliedDiscountDeltaOriginal,
  AppliedDiscountDeltaDeltaDetailsOneOf as AppliedDiscountDeltaDeltaDetailsOneOfOriginal,
  AdditionalFeeDelta as AdditionalFeeDeltaOriginal,
  AdditionalFeeDeltaDeltaDetailsOneOf as AdditionalFeeDeltaDeltaDetailsOneOfOriginal,
  CreateSubscriptionContractRequest as CreateSubscriptionContractRequestOriginal,
  CreateSubscriptionContractResponse as CreateSubscriptionContractResponseOriginal,
  GetSubscriptionContractRequest as GetSubscriptionContractRequestOriginal,
  GetSubscriptionContractResponse as GetSubscriptionContractResponseOriginal,
  UpdateSubscriptionContractRequest as UpdateSubscriptionContractRequestOriginal,
  UpdateSubscriptionContractResponse as UpdateSubscriptionContractResponseOriginal,
  QuerySubscriptionContractsRequest as QuerySubscriptionContractsRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QuerySubscriptionContractsResponse as QuerySubscriptionContractsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  BulkCreateSubscriptionContractsRequest as BulkCreateSubscriptionContractsRequestOriginal,
  BulkCreateSubscriptionContractsResponse as BulkCreateSubscriptionContractsResponseOriginal,
  BulkSubscriptionContractResult as BulkSubscriptionContractResultOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  BulkUpdateSubscriptionContractsRequest as BulkUpdateSubscriptionContractsRequestOriginal,
  MaskedSubscriptionContract as MaskedSubscriptionContractOriginal,
  BulkUpdateSubscriptionContractsResponse as BulkUpdateSubscriptionContractsResponseOriginal,
  CommitSubscriptionContractChangesRequest as CommitSubscriptionContractChangesRequestOriginal,
  SubscriptionCommitSettings as SubscriptionCommitSettingsOriginal,
  CommitSubscriptionContractChangesResponse as CommitSubscriptionContractChangesResponseOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './ecom-subscription-contracts-v1-subscription-contract-subscription-contracts.types.js';
